import newsList from './List'
import newsShow from './Show'
import newsCreate from './Create'
import newsEdit from './Edit'

const newsResource = {
  list: newsList,
  show: newsShow,
  create: newsCreate,
  edit: newsEdit,
}

export default newsResource
